import React from "react";

interface SuccessModalProps {
  isOpen: boolean;
  title?: string;
  text?: string;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  title = "完了",
  text = "処理が正常に完了しました。",
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal fixed inset-0 bg-gray-800 bg-opacity-75 flex items-start justify-center pt-10 z-50">
      <div className="bg-white rounded-lg shadow-lg w-2/3 md:w-1/2 lg:w-1/3 p-6 relative">
        {/* Closeボタン */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          &times;
        </button>

        {/* ヘッダー */}
        <div className="flex mb-4">
          <div className="border-l-8 rounded-3xl border-slate-100 mr-4"></div>
          <h2 className="text-lg text-slate-500 font-black">{title}</h2>
        </div>

        {/* 本文 */}
        <p className="text-gray-600 whitespace-pre-line">{text}</p>

        {/* フッター */}
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-iso text-white font-bold py-2 px-4 rounded-3xl hover:bg-opacity-50"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
